import { render } from "./ValidateCodeWithCaptcha.vue?vue&type=template&id=2d832887&ts=true"
import script from "./ValidateCodeWithCaptcha.vue?vue&type=script&lang=ts"
export * from "./ValidateCodeWithCaptcha.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__